import * as THREE from "three";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader.js";
import tween from "tweeen";
import { sineOut } from "eases";

// import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
// import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
// import { AfterimagePass } from 'three/examples/jsm/postprocessing/AfterimagePass.js'

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

export default class Sketch {
  constructor(options) {
    this.mouse = new THREE.Vector2();
    this.loaded = false;

    this.textures = options.textures;

    this.container = options.dom;
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.materials = [];
    this.tween = null;

    this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.width, this.height);

    this.scene = new THREE.Scene();

    this.fbxLoader = new FBXLoader();
    this.textureLoader = new THREE.TextureLoader();

    this.container.appendChild(this.renderer.domElement);

    this.camera = new THREE.PerspectiveCamera(
      70,
      this.width / this.height,
      0.001,
      1000
    );

    this.camera.position.set(0, 0, 5);

    // const parameters = {
    //   minFilter: THREE.LinearFilter,
    //   magFilter: THREE.LinearFilter,
    //   format: THREE.RGBAFormat,
    //   stencilBuffer: false,
    // };
    // const renderTarget = new THREE.WebGLRenderTarget(
    //   this.width,
    //   this.height,
    //   parameters
    // )

    // this.composer = new EffectComposer(this.renderer, renderTarget)

    // this.afterimagePass = new AfterimagePass()
    // this.afterimagePass.uniforms['damp'].value = 0.975

    // this.afterimagePas

    // this.composer.addPass(new RenderPass(this.scene, this.camera))
    // this.composer.addPass(this.afterimagePass)

    this.render = this.render.bind(this);
    this.resize = this.resize.bind(this);
    this.destroy = this.destroy.bind(this);
    this.updateTexture = this.updateTexture.bind(this);

    this.init = this.init.bind(this);

    this.grabMouse = this.grabMouse.bind(this);
  }

  async load() {
    await this.addMaterial();
    await this.addObject();
    this.loaded = true;
  }

  init(index) {
    this.render();

    tween(
      0,
      0.045,
      (value) => {
        this.mesh.scale.set(value, value, value);
      },
      {
        easing: sineOut,
        duration: 2000,
      }
    );

    tween(
      this.mesh.rotation.x,
      getRandomArbitrary(-1, 1).toFixed(1),
      (value) => {
        this.mesh.rotation.x = this.mesh.rotation.z = value;
      },
      {
        duration: 2000,
        easing: sineOut,
      }
    );

    window.addEventListener("mousemove", this.grabMouse);
    window.addEventListener("touchstart", this.grabMouse);

    this.setTexture(index);
    this.loadOther();
  }

  grabMouse(e) {
    let touches = e.targetTouches;

    let position = {
      x: touches ? touches[0].clientX : e.clientX,
      y: touches ? touches[0].clientY : e.clientY,
    };

    this.mouse.x = (position.x / this.width) * 2 - 1;
    this.mouse.y = -(position.y / this.height) * 2 + 1;
  }

  resize() {
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer.setSize(this.width, this.height);
    this.camera.aspect = this.width / this.height;
    this.camera.updateProjectionMatrix();
  }

  async addMaterial() {
    let material = await this.textureLoader.loadAsync(this.textures[0]);

    this.materials[0] = material;
  }

  async loadOther() {
    await Promise.all(
      this.textures.map(async (texture, i) => {
        let material = await this.textureLoader.loadAsync(texture);
        this.materials[i] = material;
      })
    );
  }

  async addObject() {
    this.mesh = await this.fbxLoader.loadAsync("/static/model/numi2.fbx");
    this.mesh.scale.set(0, 0, 0);

    this.scene.add(this.mesh);
  }

  setTexture(index) {
    this.material1 = new THREE.MeshMatcapMaterial({
      matcap: this.materials[index],
      transparent: true,
      opacity: 1,
    });

    this.material2 = new THREE.MeshMatcapMaterial({
      matcap: this.materials[index],
      transparent: true,
      opacity: 0.93,
    });

    this.mesh.children[1].material = this.material1;
    this.mesh.children[2].material = this.material1;
    this.mesh.children[3].material = this.material2;
    this.mesh.children[4].material = this.material2;
  }

  updateTexture(index) {
    if (!this.mesh) return;
    if (this.tween) this.tween();

    this.setTexture(index);

    this.tween = tween(
      this.mesh.rotation.x,
      getRandomArbitrary(-1, 1).toFixed(1),
      (value) => {
        this.mesh.rotation.x = this.mesh.rotation.z = value;
      },
      {
        duration: 2000,
        easing: sineOut,
      }
    );
  }

  destroy() {
    if (this.tween) this.tween();

    window.removeEventListener("mousemove", this.grabMouse);
    window.removeEventListener("touchstart", this.grabMouse);

    this.container.removeChild(this.renderer.domElement);
  }

  render() {
    this.mesh.rotation.x += ((-this.mouse.y - this.mesh.rotation.x) * 0.01) / 8;
    this.mesh.rotation.z += ((-this.mouse.x - this.mesh.rotation.z) * 0.01) / 8;

    this.renderer.render(this.scene, this.camera);
    // this.composer.render()
  }
}
